export const getPath = (path, groupSlug, topicSlug, cardSlug) => {
  return path
    .replace(':groupSlug', groupSlug)
    .replace(':topicSlug', topicSlug)
    .replace(':cardSlug', cardSlug);
};
